
import { useDelay, useGetRequest, useLog } from '@/hooks'
import { AssertGoodResponse } from '@/util/GlobalUtil'
import { defineComponent, reactive, toRefs } from 'vue'

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const l = useLog()
    const state = reactive({
      isLoading: useDelay(100).isLoading,
      friendLinks: [],
    })

    // 调接口, 获取所有友链
    useGetRequest('/api/friend_link')
      .then((res) => {
        AssertGoodResponse(res)
        state.friendLinks = res.data.data.collection
      })
      .finally(() => {
        state.isLoading = false
      })

    return {
      ...toRefs(state),
    }
  },
})
